






















import Vue from 'vue'
import VoiceEntity from '@/entities/Voice'

import TextLink from '@/components/shared/atoms/TextLink'
import { buildUrl } from '@/utils/url'

export default Vue.extend({
  components: {
    TextLink
  },
  props: {
    voicesData: {
      type: Array as () => VoiceEntity[],
      default: () => []
    },
    oneRow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route() {
      this.displayHtml()
    }
  },
  mounted() {
    this.displayHtml()
  },
  methods: {
    voicePath(voice: VoiceEntity): string {
      return buildUrl('voices-id', { id: voice.props.id })
    },
    block() {
      return false
    },
    displayHtml() {
      if (this.voicesData) {
        for (let index = 0; index < this.voicesData.length; index++) {
          const html = document.getElementById(`innerHtmlTarget${index}`)
          if (html) {
            html.innerHTML = this.voicesData[index].props.content
          }
        }
      }
    }
  }
})
